export default __webpack_public_path__ + "static/media/gac-map.6b538102.svg";